/* =============================================================================
   i18n.js — Traducción del sitio (ES / EN)
   Hotel La Gruta · Arequipa

   Arquitectura
   ------------
   Un solo diccionario plano por idioma (I18N.STRINGS), sin librerías ni
   llamadas a APIs de traducción: todo el copy en EN está escrito a mano
   acá mismo, a partir del español como única fuente de verdad. El español
   (STRINGS.es) es también el fallback si a alguna clave le faltara alguna
   traducción.

   El HTML no tiene texto traducible embebido en más de un idioma: cada nodo
   traducible lleva uno de estos atributos, y este script lo rellena:
     - data-i18n="clave"       → el textContent del elemento
     - data-i18n-html="clave"  → el innerHTML (solo para los pocos casos con
                                  <em>/<br> dentro, ej. "Todo cerca. <em>Nada
                                  de ruido.</em>" — el HTML vive en el propio
                                  string de traducción, ver STRINGS)
     - data-i18n-attr="attr:clave;attr2:clave2" → uno o más atributos
                                  (aria-label, placeholder, etc.)

   Los tres nombres de idioma del selector del menú (ESPAÑOL/ENGLISH/
   NEDERLANDS) NO pasan por este diccionario a propósito: cada idioma
   escribe su propio nombre siempre igual, sin importar el idioma activo
   (mismo patrón que cualquier selector de idioma real).

   Páginas por idioma (2026-10-13): cada idioma tiene sus propias URLs
   (RUTAS, abajo) con el texto ya escrito en el HTML. El español se edita a
   mano; /en/ lo genera scripts/generar-idiomas.mjs con este mismo
   diccionario. El idioma de la página lo dice <html lang>; el selector lleva
   a la misma página en el otro idioma (su <link rel="alternate" hreflang>) y
   recuerda la elección en localStorage ('lg-lang'). No se adivina desde
   navigator.language ni se redirige por lo guardado: la URL manda.

   Contenido dinámico (modal de habitación): el nombre/descripción corta del
   modal se leen del DOM en el momento de abrir (de nodos que este script ya
   tradujo), así que salen ya en el idioma activo sin lógica extra. El texto
   LARGO (antes `data-detail`, ahora `data-detail-key`) no vive en el DOM
   como texto visible, así que app.js lo resuelve con I18N.t(key) al abrir el
   modal — ver ensureMenuMap/openModal en app.js.
   ============================================================================= */
(function () {
  'use strict';

  var STORAGE_KEY = 'lg-lang';
  var LANGS = ['es', 'en'];
  var DEFAULT_LANG = 'es';

  var STRINGS = {
    es: {
      /* REDISEÑO 2026-10-29 */
      'rd.habitaciones.hero.titulo': 'Seis formas<br><em>de descansar</em>',
      'rd.habitaciones.hero.lead': 'Dieciocho habitaciones en Selva Alegre, Arequipa, con desayuno incluido y un jardín propio.',
      'rd.habitaciones.hero.cta': 'Consultar disponibilidad',
      'rd.habitaciones.hero.ver': 'Ver las habitaciones',
      'rd.habitaciones.catalogo.titulo': 'Elige la que va con tu viaje',
      'rd.habitaciones.noscript': 'Para ver las fotos de cada habitación, activa JavaScript o escríbenos por WhatsApp.',
      'rd.habitaciones.verMas': 'Fotos y detalles',
      'rd.habitaciones.dato.salaEstar': 'Sala de estar privada',
      'rd.habitaciones.dato.accesoJardin': 'Acceso directo al jardín',
      'rd.habitaciones.dato.areaEstar': 'Área de estar independiente',
      'rd.habitaciones.dato.camaKing': 'Cama king',
      'rd.habitaciones.dato.tresCamas': 'Tres camas',
      'rd.habitaciones.dato.dosCamas': 'Dos camas independientes',
      'rd.habitaciones.incluye.titulo': 'Lo que incluye cada noche',
      'rd.habitaciones.incluye.lead': 'Va con todas las habitaciones, de la individual a la suite.',
      'rd.habitaciones.incluye.desayuno.t': 'Desayuno incluido',
      'rd.habitaciones.incluye.desayuno.p': 'Cada mañana, frente al jardín.',
      'rd.habitaciones.incluye.wifi.t': 'Wifi gratis',
      'rd.habitaciones.incluye.wifi.p': 'Conexión sin costo durante toda tu estadía.',
      'rd.habitaciones.incluye.agua.t': 'Agua caliente 24 h',
      'rd.habitaciones.incluye.agua.p': 'A cualquier hora, en todas las habitaciones.',
      'rd.habitaciones.incluye.parking.t': 'Estacionamiento privado',
      'rd.habitaciones.incluye.parking.p': 'Gratuito y vigilado, para quien llega en auto.',
      'rd.habitaciones.incluye.horario': 'Check-in desde las 14:00 · Check-out hasta las 11:00',
      'rd.habitaciones.incluye.ver': 'Ver foto',
      'rd.habitaciones.cierre.titulo': 'Reserva directo con nosotros',
      'rd.habitaciones.cierre.p': 'Sin intermediarios: confirmamos contigo la disponibilidad. Elige tus fechas y escríbenos por WhatsApp; te ayudamos a elegir la habitación.',
      'rd.habitaciones.cierre.link': 'Ir a Reservas',
      'rd.habitaciones.cierre.foto': 'El jardín de La Gruta',
      /* REDISEÑO 2026-10-29 */
      'rd.inicio.hero.nombre': 'Hotel La Gruta · Selva Alegre, Arequipa',
      'rd.inicio.hero.titulo': 'Tu descanso, cuidado<br><em>en cada detalle.</em>',
      'rd.inicio.avail.consultar': 'Consultar disponibilidad',
      'rd.inicio.avail.nota': 'Se abre WhatsApp con tus fechas y confirmamos contigo la disponibilidad.',
      'rd.inicio.intro.titulo': 'Un remanso en la ciudad',
      'rd.inicio.intro.jardin': 'Para bajar el ritmo, entre hortensias y terrazas.',
      'rd.inicio.habs.intro': 'Seis tipos de habitación, todas con desayuno incluido, wifi y agua caliente las 24 horas.',
      'rd.inicio.svc.desayuno': 'Cada mañana, en el comedor frente al jardín.',
      'rd.inicio.svc.rest': 'Dentro del hotel, para cada día.',
      'rd.inicio.svc.jardin': 'Para bajar el ritmo, a pocos minutos del centro histórico.',
      'rd.inicio.svc.parking': 'Gratuito y vigilado, dentro del hotel.',
      'rd.inicio.svc.wifi': 'Conexión sin costo durante toda tu estadía.',
      'rd.inicio.svc.agua': 'En tu habitación, a cualquier hora del día.',
      'rd.inicio.gastro.titulo': 'Desayuno frente al jardín',
      'rd.inicio.cierre.titulo': 'Reserva directo con el hotel',
      'rd.inicio.cierre.apoyo': 'Confirmamos contigo la disponibilidad y te respondemos personalmente.',
      'rd.inicio.cierre.cta': 'Reservar mi estadía',
      /* REDISEÑO 2026-10-30 · Inicio por referencias */
      'rd.inicio.hero.reservar': 'Reservar estancia',
      'rd.inicio.hero.habitaciones': 'Ver habitaciones',
      'rd.inicio.hab.reserva': 'Reserva rápida',
      'rd.inicio.hab.n2': '2 habitaciones',
      'rd.inicio.hab.n3': '3 habitaciones',
      'rd.inicio.hab.n4': '4 habitaciones',
      'rd.inicio.hab.n5': '5 habitaciones',
      'rd.inicio.res.google': 'Google · 154 opiniones',
      'rd.inicio.res.ta': 'Tripadvisor · 119 opiniones',
      'rd.inicio.res.q1': '“El personal es amable, servicial y acogedor.”',
      'rd.inicio.res.q2': '“Lugar cómodo, habitación cómoda a la que me trajeron la comida y un entorno tranquilo.”',
      'rd.inicio.res.q3': '“Excelente trato. Un hotel muy cómodo, con jardines preciosos, que vale la pena tener en cuenta.”',
      'rd.inicio.res.c1': 'Karena V · Tripadvisor · septiembre de 2026',
      'rd.inicio.res.c2': 'Andrew G · Tripadvisor · septiembre de 2026',
      'rd.inicio.res.c3': 'Jesus H · Tripadvisor · septiembre de 2026',
      'rd.inicio.res.titulo': 'Lo que cuentan quienes nos visitaron',
      'rd.reservas.hero.titulo': 'Reserva directa<br><em>en La Gruta</em>',
      'rd.reservas.hero.texto': 'Cuéntanos tus fechas y confirmamos contigo la disponibilidad, sin intermediarios.',
      'rd.reservas.hero.cta': 'Consultar disponibilidad',
      'rd.reservas.hero.wa': 'o escríbenos por WhatsApp',
      'rd.reservas.ventajas.titulo': 'Lo que ganas al reservar directo',
      'rd.reservas.ventajas.1.titulo': 'Sin intermediarios',
      'rd.reservas.ventajas.1.texto': 'Hablas directamente con el hotel y te ayudamos a elegir habitación.',
      'rd.reservas.ventajas.2.texto': 'La tarifa de hospedaje incluye el desayuno.',
      'rd.reservas.ventajas.3.titulo': 'Check-in 14:00, check-out 11:00',
      'rd.reservas.ventajas.3.texto': 'Si necesitas otro horario, consúltalo con el hotel.',
      'rd.reservas.form.titulo': 'Envíanos tu consulta',
      'rd.reservas.form.texto': 'Completa el formulario y se abrirá WhatsApp con tu mensaje listo. Tú decides si lo envías.',
      'rd.reservas.confianza.titulo': 'Lo que opinan nuestros huéspedes',
      'rd.reservas.confianza.cta': 'Consultar mis fechas',
      'rd.reservas.condiciones.titulo': 'Condiciones de reserva y estadía',
      'rd.reservas.canales.titulo': 'Escríbenos o llámanos',
      'rd.reservas.canales.texto': 'Si prefieres conversarlo, te atendemos personalmente por WhatsApp o por teléfono.',
      'rd.reservas.canales.wa': 'Escribir por WhatsApp',
      'rd.reservas.canales.tel': 'Llamar al +51 974 330 699',
      'rd.estrellas.5': '5 de 5 estrellas',
      'rd.mapa.nombre': 'Mapa de ubicación de Hotel La Gruta',
      'rd.reservas.canales.nota': 'WhatsApp +51 974 330 699 · Correo:',
      'rd.experiencias.hero.sub': 'Del Cañón del Colca a los volcanes: siete salidas que organizamos contigo desde recepción.',
      'rd.experiencias.tours.lead': 'Siete salidas que organizamos desde el hotel. Escríbenos por la que te interese y te confirmamos los detalles.',
      'rd.experiencias.organiza.titulo': 'Lo organizamos desde recepción',
      'rd.experiencias.cierre.titulo': 'Reserva y armamos tu plan',
      'rd.experiencias.cierre.texto': 'Reserva tu estadía y te ayudamos a armar tu plan en Arequipa. Confirmamos contigo la disponibilidad.',
      'rd.experiencias.cierre.wa': 'Planear mi día por WhatsApp',
      'rd.galeria.hero.lead': 'Hotel con jardín propio en Selva Alegre, Arequipa. Desayuno incluido y reserva directa.',
      'rd.galeria.hero.ver': 'Ver la galería',
      'rd.galeria.prueba': '4,4 de 5 en Tripadvisor',
      'rd.galeria.intro': 'Fotos del hotel en cuatro paseos: el jardín, las habitaciones, la mesa y la recepción.',
      'rd.galeria.jardin.titulo': 'El jardín',
      'rd.galeria.jardin.texto': 'Entre hortensias, rosas y terrazas con mesas, el jardín invita a bajar el ritmo.',
      'rd.galeria.cap.gruta': 'Gruta de piedra al costado del hotel, con un adorno decorativo.',
      'rd.galeria.cap.pergola': 'Pérgola con sillones, entre las terrazas del jardín.',
      'rd.galeria.jardin.nota': 'Mesas bajo sombrilla, una pérgola con sillones y una escalinata de piedra entre las terrazas.',
      'rd.galeria.hab.titulo': 'Seis tipos de habitación',
      'rd.galeria.hab.texto': 'De la Individual a la Suite, para viajar solo, en pareja o en grupo. Las suites 104 y 212 tienen jacuzzi.',
      'rd.galeria.cap.suite': 'Suite: jacuzzi junto a la cama.',
      'rd.galeria.cap.semisuite': 'Semi Suite: dormitorio y sala separados.',
      'rd.galeria.cap.matrimonial': 'Matrimonial: escritorio y luz natural.',
      'rd.galeria.hab.nota': 'Cada tipo tiene su ficha con capacidad, fotos y reserva directa.',
      'rd.galeria.hab.link': 'Ver las habitaciones',
      'rd.galeria.cap.doble': 'Doble: dos camas.',
      'rd.galeria.cap.triple': 'Triple: tres camas.',
      'rd.galeria.cap.individual': 'Individual: con escritorio.',
      'rd.galeria.mesa.titulo': 'El desayuno está incluido',
      'rd.galeria.mesa.texto': 'Fruta, panes, jugos y café cada mañana, en un comedor con ventanales al jardín. También hay restaurante y bar.',
      'rd.galeria.cap.comedor': 'Comedor con ventanales hacia el jardín.',
      'rd.galeria.casa.titulo': 'Recepción y sala, de día y de noche',
      'rd.galeria.casa.texto': 'Recepción de madera, una sala con libros y estacionamiento privado, en Selva Alegre, Arequipa.',
      'rd.galeria.casa.nota': 'Wifi gratis y agua caliente las 24 horas.',
      'rd.galeria.prueba.bookingNota': '«Fantástico» en Booking',
      'rd.galeria.prueba.tripNota': 'de 5 en Tripadvisor',
      'rd.galeria.prueba.casaNota': 'Desayuno incluido, wifi gratis y estacionamiento privado.',
      // Condiciones de reservas: ver docs/RESERVAS-CONDICIONES.md.
      "footer.terms": "Términos y condiciones",
      "footer.data": "Información sobre tus datos",
      "footer.claims": "Libro de Reclamaciones",
      "footer.legalNav": "Información de reservas",
      "rv.consultNotice": "Enviar esta consulta no confirma tu reserva. El hotel te comunicará la disponibilidad, la tarifa y las condiciones aplicables.",
      "rv.dataLink": "Conoce cómo funciona el envío de tus datos",
      "rv.process.eye": "Cómo reservar",
      "rv.process.title": "Tu estadía, <em>paso a paso</em>",
      "rv.process.1.title": "Cuéntanos tus fechas",
      "rv.process.1.text": "Consulta por WhatsApp o correo. Indícanos las fechas, el número de huéspedes y la habitación que prefieres.",
      "rv.process.2.title": "Recibe tu propuesta",
      "rv.process.2.text": "El hotel te informa la disponibilidad, la tarifa, los servicios incluidos y las condiciones de tu estadía.",
      "rv.process.3.title": "Coordina la confirmación",
      "rv.process.3.text": "Acuerda con el hotel el adelanto, el saldo y el medio de pago. Solicita la confirmación de tu reserva por el canal de atención.",
      "rv.process.cta": "Empieza por WhatsApp",
      "rv.process.formLink": "Prefiero completar el formulario",
      "rv.terms.eye": "Información para tu estadía",
      "rv.terms.title": "Condiciones de reserva <em>y estadía</em>",
      "rv.terms.intro": "Consulta esta información antes de confirmar. El hotel te indicará las condiciones específicas de tu propuesta y atenderá tus dudas personalmente.",
      "rv.terms.updated": "Actualizado el 11 de octubre de 2026",
      "rv.terms.payment.title": "Reservas y medios de pago",
      "rv.terms.payment.text": "Las consultas están sujetas a disponibilidad. Habitualmente se coordina un adelanto del 50 % del total de la reserva; el importe, el plazo y el pago del saldo se acuerdan directamente con el hotel.",
      "rv.terms.payment.note": "Confirma la disponibilidad y el importe con el hotel antes de realizar una transferencia o un pago por Yape.",
      "rv.terms.payment.bank": "Transferencia bancaria en soles",
      "rv.terms.payment.holder": "Titular",
      "rv.terms.payment.account": "Cuenta corriente BCP en soles",
      "rv.terms.payment.cci": "Código de cuenta interbancaria (CCI)",
      "rv.terms.payment.yape": "Yape · LUCIUS S.A.C.",
      "rv.terms.payment.agencies": "Para agencias, empresas o grupos, coordina directamente el adelanto, el saldo y los plazos antes de confirmar.",
      "rv.terms.changes.title": "Cambios y cancelaciones",
      "rv.terms.changes.text": "Antes de confirmar o realizar un adelanto, solicita al hotel las condiciones aplicables a cambios, cancelaciones, devolución del adelanto, no presentación y salida anticipada. Estas gestiones se coordinan directamente por WhatsApp o correo.",
      "rv.terms.stay.title": "Llegada, salida y solicitudes especiales",
      "rv.terms.stay.hours": "Check-in desde las 14:00. Check-out hasta las 11:00.",
      "rv.terms.stay.text": "Para ingreso anticipado, salida tardía, estadías con menores, mascotas o visitas, consulta las condiciones con el hotel antes de confirmar tu reserva.",
      "rv.terms.services.title": "Servicios incluidos y consumos adicionales",
      "rv.terms.services.text": "La tarifa de hospedaje incluye desayuno. El estacionamiento privado es gratuito. Consulta el precio y las condiciones de lavandería, cafetería, servicio a la habitación y otros alimentos o bebidas antes de solicitarlos.",
      "rv.terms.bridal.title": "Paquete de novias",
      "rv.terms.bridal.text": "El Paquete de novias se coordina personalmente. Consulta por desayuno buffet, servicio a la habitación, decoración, jacuzzi, fotografías en el jardín y vino o espumante de cortesía. La habitación, la duración, la anticipación, el precio y las inclusiones se confirman en la propuesta del hotel.",
      "rv.terms.bridal.cta": "Consultar el Paquete de novias",
      "rv.terms.data.title": "Información sobre tus datos",
      "rv.terms.data.text": "Este formulario prepara una consulta con el nombre, teléfono, correo opcional, fechas, huéspedes, habitación y mensaje que introduces. Al elegir WhatsApp o correo, se abre ese servicio con el mensaje preparado; tú decides si lo envías. No se realiza ningún cobro desde esta web.",
      "rv.terms.data.contact": "Para consultas sobre la información que compartes, escribe al correo oficial del hotel.",
      "rv.terms.claims.title": "Libro de Reclamaciones",
      "rv.terms.claims.text": "El hotel dispone de un Libro de Reclamaciones físico. Puedes solicitarlo al personal durante tu visita.",
      "rv.terms.business.title": "Datos del establecimiento",
      "rv.terms.business.name": "Razón social",
      "rv.terms.business.tax": "RUC",
      "rv.terms.business.address": "Domicilio",
      "rv.terms.business.email": "Correo oficial de atención",

      'nav.book': '▸ Reservar',
      // Marco (header + barra inferior móvil): ver "MARCO" en site.css.
      'hdr.directions': 'Cómo llegar',
      'stack.showAll': 'Ver todos',
      'hdr.navLabel': 'Navegación principal',
      'bar.menu': 'Menú',
      'bar.mail': 'Correo',
      'bar.close': 'Cerrar',
      'bar.book': 'Reservar',
      'wa.short': 'Escríbenos',
      'menu.social.label': 'Síguenos',
      'menu.nav.home': 'Inicio',
      'menu.nav.rooms': 'Habitaciones',
      'menu.nav.reservas': 'Reservas',
      'menu.nav.experiencias': 'Experiencias',
      'menu.nav.galeria': 'Galería',
      'hero.galeria.title': 'La Gruta<br><em>en imágenes</em>',
      'gal.eyebrow': 'Galería',
      'gal.title': 'La Gruta, de cerca',
      'gal.intro': 'Un recorrido por nuestras habitaciones, el jardín, la mesa y la ciudad que nos rodea.',
      'gal.cta.title': '¿Te imaginas aquí?',
      'gal.cta.text': 'Cuéntanos tus fechas y te confirmamos disponibilidad personalmente.',
      'gal.filtrosLabel': 'Filtrar fotos',
      'gal.f.todas': 'Todas',
      'gal.f.hotel': 'El hotel',
      'gal.f.habitaciones': 'Habitaciones',
      'gal.f.gastronomia': 'Gastronomía',
      'gal.f.arequipa': 'Arequipa',
      'gal.visor.label': 'Visor de fotos',
      'gal.visor.cerrar': 'Cerrar',
      'gal.visor.anterior': 'Foto anterior',
      'gal.visor.siguiente': 'Foto siguiente',
      // Galería: texto alternativo de cada foto (también es el pie del visor).
      'gal.p.fachada-jardin': 'Fachada de La Gruta vista desde el jardín, con toldos y mesas sobre el césped',
      'gal.p.suite': 'Suite con cama king y detalles de bienvenida',
      'gal.p.hortensias': 'Hortensias azules frente al muro del jardín',
      'gal.p.catedral-misti': 'Catedral de Arequipa y el volcán Misti al atardecer',
      'gal.p.sombrilla': 'Mesa bajo sombrilla entre la vegetación del jardín',
      'gal.p.desayuno-mesa': 'Desayuno servido: fruta, panes, jugos y café',
      'gal.p.semisuite': 'Semi Suite con dormitorio y sala separados',
      'gal.p.patio-amarillo': 'Patio con hortensias frente a la fachada amarilla del hotel',
      'gal.p.matrimonial': 'Habitación Matrimonial con escritorio y luz natural',
      'gal.p.matrimonial-sala': 'Matrimonial con sala de estar y escritorio',
      'gal.p.colca': 'Cóndor sobrevolando el Cañón del Colca',
      'gal.p.jacuzzi-suite': 'Jacuzzi de la Suite preparado con pétalos y velas',
      'gal.p.cafe-libro': 'Café y un libro abierto en la terraza del jardín',
      'gal.p.suite-cama': 'Cama de la Suite con detalles para una ocasión especial',
      'gal.p.recepcion-noche': 'Entrada del hotel iluminada al anochecer',
      'gal.p.santa-catalina': 'Patio del Monasterio de Santa Catalina',
      'gal.p.comedor': 'Comedor con ventanales hacia el jardín',
      'gal.p.triple': 'Habitación Triple con tres camas',
      'gal.p.triple-camas': 'Triple con tres camas y paneles de madera',
      'gal.p.pergola': 'Pérgola con sillones en el jardín',
      'gal.p.balcon-jardin': 'Balcón con vista al jardín y a las terrazas de piedra',
      'gal.p.misti-nubes': 'El volcán Misti sobre un mar de nubes',
      'gal.p.semisuite-sala': 'Sala de la Semi Suite con sillones',
      'gal.p.escalinata': 'Escalinata de piedra hacia el jardín',
      'gal.p.doble': 'Habitación Doble con dos camas',
      'gal.p.buffet': 'Buffet de desayuno con panes y platos calientes',
      'gal.p.ventanal': 'Ventanal de la habitación con vista al jardín',
      'gal.p.bano-suite': 'Baño de la Suite con ducha de vidrio',
      'gal.p.yanahuara': 'Arcos de sillar del mirador de Yanahuara, con el Misti al fondo',
      'gal.p.doble-sala': 'Zona de estar con sillones en la habitación Doble',
      'gal.p.individual': 'Habitación Individual con escritorio',
      'gal.p.bano-semisuite': 'Baño de la Semi Suite',
      'gal.p.sillar': 'Canteras de sillar en las afueras de Arequipa',
      'gal.p.individual-sala': 'Sillones junto al ventanal de la habitación Individual',
      'gal.p.bano-matrimonial': 'Baño de la Matrimonial con ducha de bloques de vidrio',
      'gal.p.pillones': 'Catarata de Pillones',
      'gal.p.bano-triple': 'Baño de la Triple',
      'gal.p.rafting': 'Rafting en el río Chili',
      'gal.p.gruta': 'La gruta de piedra cubierta de vegetación, entre cactus',
      'gal.p.recepcion': 'Recepción con mostrador de madera y piso de baldosas',
      'gal.p.hora-azul': 'El edificio del hotel con sus luces encendidas en la hora azul',
      'gal.p.rosas-ventana': 'Rosas rosadas en un jarrón junto a la ventana, con el follaje del jardín detrás',
      'gal.p.fachada-azul': 'Fachada de La Gruta al anochecer, con el cielo azul y las luces encendidas',
      'gal.p.ventana-jardin': 'El jardín visto desde una ventana',
      'gal.p.rosas': 'Rosas de colores en el jardín, junto a la escalera',
      'gal.p.terraza-atardecer': 'Mesa con sombrilla en la terraza al atardecer',
      'gal.p.sala-lectura': 'Zona de estar con librero y sillones',
      'gal.p.suite-jacuzzi': 'Suite con jacuzzi junto a la cama',
      'gal.p.desayuno-jugos': 'Café y jugos en el buffet del desayuno',
      'gal.p.terraza-plantas': 'Terraza con mesa, sombrilla y plantas',
      'gal.p.escalera-flores': 'Escalera exterior y balcón entre flores',
      'gal.p.estacionamiento': 'Estacionamiento privado del hotel',
      'gal.p.misti-campina': 'La campiña arequipeña con el Misti al fondo',

      'hero.home.title': 'Tu descanso, cuidado <em>en cada detalle.</em>',
      'hero.home.sub': 'Hotel boutique en Selva Alegre, Arequipa.',
      'hero.rooms.title': 'Descansa con el confort y la calma de La Gruta.',
      'hero.reservas.title': 'Tu próxima pausa empieza aquí.',
      'hero.experiencias.title1': 'Vive Arequipa',
      'hero.experiencias.title2': 'desde La Gruta',

      'avail.checkin': 'Check In',
      'avail.checkout': 'Check Out',
      'avail.guests': 'Huéspedes',
      'avail.guest1': '1 huésped',
      'avail.guest2': '2 huéspedes',
      'avail.guest3': '3 huéspedes',
      'avail.guest4': '4+ huéspedes',
      'avail.consult': 'Consultar',
      'avail.dateFormat': 'dd/mm/aaaa',

      /* Nombres accesibles del buscador del hero (Ronda 24). Viven en
         <label class="sr-only">: no se ven, pero son el nombre que anuncia
         un lector de pantalla y el que escucha el control por voz. Son más
         explícitos que las etiquetas visibles ("Check In") porque fuera del
         contexto visual del buscador hay que poder distinguir una fecha de
         la otra sin verlas juntas. */
      'avail.a11y.checkin': 'Fecha de llegada',
      'avail.a11y.checkout': 'Fecha de salida',
      'avail.a11y.guests': 'Número de huéspedes',
      'picker.clear': 'Borrar',
      'picker.prevMonth': 'Mes anterior',
      'picker.nextMonth': 'Mes siguiente',

      'welcome.editorial.eye': 'Bienvenido a La Gruta',
      'welcome.editorial.title': 'Un remanso en la ciudad.<br>Otra forma de <em>vivir</em> Arequipa.',
      'welcome.editorial.desc': 'A pocos minutos del centro histórico, un jardín para bajar el ritmo. Habitaciones confortables, atención cercana y la calma de sentirte bien cuidado.',
      'welcome.editorial.caption': 'El jardín de La Gruta · Selva Alegre',
      'welcome.sello': '4,4 de 5<br>Tripadvisor',
      'welcome.ben.desayuno': 'Desayuno incluido',
      'welcome.ben.parking': 'Estacionamiento privado',
      'welcome.ben.wifi': 'Wifi gratuito',
      'cl.sellos.label': 'Valoraciones de huéspedes',
      'cl.hab.fotos': 'Ver fotos',
      'cl.wa': 'Escríbenos por WhatsApp',
      'cl.svc.title': 'Pensado para tu <em>comodidad</em>',
      'cl.svc.rest': 'Restaurante y bar',
      'cl.svc.jardin': 'Hermosos jardines',
      'cl.svc.agua': 'Agua caliente las 24 horas',
      'cl.comollegar': 'Cómo llegar',
      'cl.visor.cerrar': 'Cerrar',
      'cl.visor.prev': 'Foto anterior',
      'cl.visor.next': 'Foto siguiente',
      'cl.visor.ampliar': 'Ampliar foto',
      'welcome.cta.book': 'Reserva directa',
      'rd.inicio.remanso.wa': 'Consultar por WhatsApp',
      'welcome.cta.wa': 'Escríbenos por WhatsApp',
      'welcome.cta.nota': 'Sin intermediarios: confirmamos contigo la disponibilidad.',
      'welcome.cta.horario': 'Check‑in 14:00 · check‑out 11:00.',
      'welcome.sello.sr': 'Puntuación en Tripadvisor:',
      'rooms.editorial.title': 'Elige tu forma de <em>descansar.</em>',
      'rooms.editorial.all': 'Todas las habitaciones ↗',
      'rooms.editorial.explore': 'Explorar esta habitación ↗',
      'welcome.script': 'Bienvenido a',
      'welcome.title': 'Un jardín donde la <em>Ciudad Blanca</em> se vuelve calma.',
      'welcome.desc': 'La Gruta cuenta con hermosos jardines y se encuentra en una elegante zona residencial, a pocos minutos del centro histórico de Arequipa y de la zona comercial. Ofrece un ambiente familiar, un trato cordial y atento, y habitaciones amplias, confortables y totalmente alfombradas.',

      'homemap.eyebrow': 'Por qué La Gruta',
      'homemap.title': 'Aquí, el silencio <em>es parte del servicio.</em>',
      'homemap.desc': 'En una calle tranquila de Selva Alegre, La Gruta reúne un jardín propio, habitaciones confortables y atención personalizada. El centro histórico queda a un paseo, para disfrutar Arequipa a tu ritmo.',
      'homemap.addressLabel': 'Dirección',
      'homemap.checkinLabel': 'Check-in',
      'homemap.checkoutLabel': 'Check-out',
      'homemap.directions': 'Cómo llegar ›',
      'homemap.book': 'Reservar directo',
      'homemap.plaza': 'Plaza de Armas',
      'homemap.poi.santa-catalina': 'Santa Catalina',
      'homemap.poi.san-francisco': 'San Francisco',
      'homemap.poi.campo-redondo': 'Campo Redondo',
      'homemap.poi.bares': 'Bares y cafés',
      'homemap.recenter': 'Centrar en el hotel y la Plaza de Armas',

      'bodas.eyebrow': "Paquete de novias",
      'bodas.title': 'Alístate y posa en <em>nuestro jardín</em>',
      'bodas.desc': 'Llega a La Gruta para cambiarte, maquillarte y alistarte con calma, y cierra con una sesión de fotos en nuestro jardín. Un comienzo sereno y sin prisas para tu gran día.',
      'bodas.cta': "Consultar el Paquete de novias",
      'bodas.note': 'Sin compromiso · Te respondemos personalmente',

      'reviews.eyebrow': 'Opiniones de huéspedes',
      'reviews.title': 'Lo que nuestros huéspedes recuerdan',
      'reviews.booking.tag': 'Fantástico',
      'reviews.booking.count': '15 comentarios',
      'reviews.tripadvisor.count': '119 opiniones',
      'reviews.ta.bravo': '¡Bravo!',
      'reviews.ta.score': '4,4 de 5',
      'reviews.booking.score': '9,3',
      'reviews.t2.date': 'set. 2026',
      'reviews.arrow': 'Ver más opiniones',
      'reviews.cta.text': 'Reserva directo con el hotel: te atendemos personalmente.',
      'reviews.cta.btn': 'Consultar disponibilidad',
      'reviews.b1.country': 'Lituania',
      'reviews.b1.text': 'Hermoso y tranquilo lugar en Arequipa con una recepcionista absolutamente excepcional. ¡¡Muchas gracias por toda su ayuda!!',
      'reviews.b2.country': 'Chile',
      'reviews.b2.text': 'Lugar tranquilo, amabilidad del personal, el desayuno variado, camas cómodas.',
      'reviews.t2.text': 'El hotel es muy cómodo, limpio y el personal es muy atento.',

      'rooms.count': 'Habitaciones',
      'rooms.info.title': 'Tu estadía, cuidada <em>en cada detalle</em>',
      'rooms.info.text': 'Todas nuestras habitaciones incluyen desayuno frente al jardín, wifi gratuito, agua caliente las 24 horas y estacionamiento privado vigilado. <strong>Reserva directamente con nosotros y te ayudamos a elegir la habitación ideal</strong>, coordinamos tu traslado y, si lo deseas, un masaje con cita previa para cerrar el día.',
      'rooms.viewAll': 'Ver todas',
      'rooms.viewMore': 'Ver más',
      'rooms.book': 'Reservar',
      'rooms.suite.name': 'Suite',
      'rooms.suite.descShort': 'Nuestra suite más exclusiva: jacuzzi para dos, sala de estar privada y acceso directo al jardín.',
'rooms.suite.detail': 'El espacio más amplio y reservado de La Gruta. Acceso directo al jardín, una sala de estar separada del dormitorio y un jacuzzi para dos para cerrar el día en calma. Ideal para estancias largas, aniversarios o para disfrutar una estadía con más espacio y comodidad.',
      'rooms.matrimonial.name': 'Matrimonial',
      'rooms.matrimonial.descHomeShort': 'Cama king y vista al jardín para compartir una estadía tranquila en pareja.',
      'rooms.matrimonial.descShort': 'Cama king y vista al jardín, pensada para el descanso en pareja.',
      'rooms.matrimonial.detail': 'Una cama king, la luz del jardín por la ventana y la calma de Selva Alegre. Un espacio para disfrutar Arequipa en pareja, con el confort y la atención de La Gruta.',
      'rooms.semisuite.name': 'Semi Suite',
      'rooms.semisuite.descShort': 'Área de estar independiente y vista al jardín: el confort de una suite en un formato más íntimo.',
      'rooms.semisuite.detail': 'El confort de una suite en un formato más íntimo. Tiene un área de estar independiente para leer, trabajar o compartir un café al final del día, con el jardín siempre como vista.',
      'rooms.triple.name': 'Triple',
      'rooms.triple.descShort': 'Tres camas y amplitud para que todos descansen igual de bien, en familia o entre amigos.',
      'rooms.triple.detail': 'Tres camas en un ambiente amplio, pensado para viajar en familia o en grupo sin sacrificar comodidad. Espacio para moverse con soltura y la misma calma que en el resto del hotel, para que todos despierten descansados.',
      'rooms.doble.name': 'Doble',
      'rooms.doble.descShort': 'Dos camas independientes en un ambiente sereno, ideal para compartir el viaje con comodidad.',
      'rooms.doble.detail': 'Dos camas independientes en un ambiente sereno: la elección natural para amigos o compañeros de viaje que quieren compartir la habitación, no la cama. Todo el confort de La Gruta, con la privacidad de un descanso propio.',
      'rooms.individual.name': 'Individual',
      'rooms.individual.descShort': 'Una habitación acogedora para viajar a tu ritmo y descansar con comodidad.',
      'rooms.individual.detail': 'Acogedora y pensada para quien viaja solo: un espacio cómodo para organizar el día, descansar bien y disfrutar Arequipa a tu ritmo.',

      'jardin.title': 'Un jardín para detener el tiempo',
      'jardin.desc': 'El jardín de La Gruta, con árboles añosos, invita a disfrutar el aire libre. Toma el sol sobre el pasto, lee a la sombra o comparte un café al atardecer. Es el corazón del hotel y parte de cada estadía.',
      'novia.eyebrow': "Paquete de novias",
      'novia.title': 'Antes del gran sí,<br><em>un momento para ti.</em>',
      'novia.desc': 'Prepárate con calma, disfruta una pausa y guarda tus primeras fotos en el jardín de La Gruta. Un comienzo a tu ritmo, antes de salir a vivir tu gran día.',
      'novia.preparar.title': 'Tu espacio para alistarte',
      'novia.preparar.desc': 'Una habitación para cambiarte y maquillarte sin apuro.',
      'novia.pausa.title': 'Una pausa para ti',
      'novia.pausa.desc': 'Relájate y disfruta algo de comer antes de salir.',
      'novia.fotos.title': 'Tus primeras fotos',
      'novia.fotos.desc': 'El jardín del hotel como escenario para tu sesión de fotos.',
      'novia.cta': 'Consultar mi fecha',
      'novia.note': "Cuéntanos tu fecha. Te detallaremos la habitación, los servicios, el precio y las condiciones del Paquete de novias.",
      'novia.whatsapp': "https://wa.me/51974330699?text=Hola%20Hotel%20La%20Gruta%2C%20quisiera%20consultar%20disponibilidad%20y%20detalles%20del%20paquete%20de%20novias.",
      'novia.jardin.alt': 'Jardín de La Gruta, con árboles, flores y espacios al aire libre',
      'novia.jardin.caption': 'El jardín, parte de tu historia.',
      'novia.habitacion.alt': 'Una de las habitaciones de La Gruta',
      'novia.habitacion.caption': 'Un espacio para prepararte a tu ritmo.',

      'gastro.eyebrow': 'Restaurante & Bar',
      'gastro.chip.breakfast': 'Desayuno',
      'gastro.chip.rest': 'Restaurante',
      'gastro.chip.bar': 'Barra libre',
      'gastro.chip.wine': 'Vinos y champán',
      'gastro.title': 'Desayuno y cocina arequipeña, <em>frente al jardín</em>',
      'gastro.desc': 'Empieza el día sin prisa, frente al jardín, en nuestro comedor. También hay restaurante y bar.',
      'gastro.note': 'Para completar la experiencia: masajes en el hotel con cita previa. Coordínalo en recepción.',
      'gastro.cta': 'Reservar con desayuno incluido',

      'faq.eyebrow': 'Ayuda',
      'faq.title': 'Preguntas <em>frecuentes</em>',
      'faq.q1': '¿A qué hora es el check-in y el check-out?',
      'faq.a1': "Check-in desde las 14:00 y check-out hasta las 11:00. Para ingreso anticipado o salida tardía, consulta las condiciones con el hotel antes de reservar.",
      'faq.q2': '¿Cómo reservo?',
      'faq.a2': 'Por WhatsApp (+51 974 330 699), por el formulario de esta web o escribiéndonos a {correo}. Te respondemos personalmente y confirmamos contigo la disponibilidad.',
      // Texto del HTML estático (sin la dirección: la arma correo.js al cargar).
      'faq.a2.sinCorreo': 'Por WhatsApp (+51 974 330 699), por el formulario de esta web o escribiéndonos por correo. Te respondemos personalmente y confirmamos contigo la disponibilidad.',
      'faq.q3': '¿Tienen estacionamiento?',
      'faq.a3': 'Sí, estacionamiento privado dentro del hotel, gratuito y vigilado.',
      'faq.q4': '¿Dónde están exactamente?',
      'faq.a4': 'Pasaje La Gruta 304, Urb. Selva Alegre: una calle tranquila en un barrio residencial de Arequipa, lejos del bullicio.',
      'faq.q5': '¿Se pueden hacer tours desde el hotel?',
      'faq.a5': 'Sí. Desde recepción organizamos city tours, Cañón del Colca, rafting y más, con operadores locales de confianza.',
      'faq.q6': '¿Aceptan mascotas?',
      'faq.a6': 'Escríbenos por WhatsApp antes de reservar y lo coordinamos según disponibilidad.',
      'faq.bridge': '¿No encontraste tu respuesta?',

      'footer.tagline': 'Hotel boutique · Arequipa, Perú',
      'footer.desc': 'Jardín, confort y atención personalizada en Arequipa.',
      'footer.navTitle': 'Navegación',
      'footer.contactTitle': 'Contacto',
      'footer.near': 'Hotel boutique en Selva Alegre, Arequipa.',
      'footer.credit': '',

      'experience.eyebrow': 'La experiencia',
      'experience.title': 'Momentos para disfrutar sin prisa',

      'rv.eye': 'Directo con el hotel',
      'rv.title': 'Diseñemos juntos <em>tu estadía.</em>',
      'rv.desc': 'Cuéntanos tus fechas y lo que esperas de tu viaje. Te recomendaremos la habitación ideal y confirmaremos la disponibilidad personalmente.',
      'rv.contact.whatsapp': 'WhatsApp',
      'rv.contact.phone': 'Teléfono',
      'rv.contact.email': 'Email',
      'rv.contact.checkinout': 'Check-in / out',

      'contact.eyebrow': 'Reserva directa',
      'contact.title': 'Escríbenos, te respondemos <em>personalmente.</em>',
      'contact.desc': 'Consulta disponibilidad, tarifas o cualquier detalle de tu estadía. Te respondemos personalmente.',
      'rv.form.requiredNote': 'Campos obligatorios',
      'rv.form.label': 'Formulario de consulta',
      'rv.form.nombre': 'Nombre completo',
      'rv.form.nombrePh': 'Tu nombre',
      'rv.form.telefono': 'Teléfono',
      'rv.form.correo': 'Correo electrónico',
      'rv.form.correoPh': 'correo@ejemplo.com',
      'rv.form.habitacion': 'Habitación',
      'rv.form.seleccionar': 'Seleccionar',
      'rv.form.huespedes': 'Huéspedes',
      'rv.form.huespedesPh': '1',
      'rv.form.llegada': 'Llegada',
      'rv.form.salida': 'Salida',
      'rv.form.mensaje': 'Mensaje adicional',
      'rv.form.mensajePh': '¿Celebras algo especial? ¿Alguna preferencia?',
      'rv.form.submit': 'Consultar disponibilidad por WhatsApp',
      "rv.err.required": "Completa este campo.",
      "rv.err.email": "Escribe un correo válido, por ejemplo nombre@correo.com.",
      "rv.err.past": "La llegada no puede ser anterior a hoy.",
      "rv.err.range": "La salida debe ser posterior a la llegada.",
      "rv.err.summary": "Revisa los campos marcados para enviar tu consulta.",
      "rv.note.wa": "Se abrió WhatsApp con tu solicitud lista para enviar.",
      "rv.note.mail": "Se abrió tu cliente de correo con la solicitud lista para enviar.",
      'rv.form.mailtoLink': 'Prefiero consultar por correo',
      'rv.card1.title': 'Llegada y salida',
      'rv.card1.text': "Check-in desde las 14:00 y check-out hasta las 11:00. Consulta con el hotel si necesitas otro horario.",
      'rv.card2.title': 'Reserva directa',
      'rv.card2.text': 'Sin intermediarios: confirmamos contigo la disponibilidad antes de reservar y te ayudamos a elegir la habitación.',
      'rv.card3.title': 'Desayuno incluido',
      'rv.card3.text': "La tarifa de hospedaje incluye desayuno. Consulta con el hotel los demás alimentos, bebidas y servicios que deseas solicitar.",
      'rv.card4.title': "Estacionamiento gratuito",
      'rv.card4.text': "Estacionamiento privado gratuito para huéspedes del hotel.",
      'rv.cards.eye': 'Antes de reservar',
      'rv.cards.title': 'Lo esencial, <em>a la vista</em>',
      'a11y.skip': 'Saltar al contenido',
      'meta.title': 'Hotel La Gruta | Hotel boutique con jardín en Arequipa',
      'meta.page': '{page} | Hotel La Gruta, Arequipa',
      'meta.desc': 'Hotel boutique en Selva Alegre, Arequipa: jardín propio, habitaciones amplias y confortables, desayuno incluido y atención personalizada. Reserva directa.',
      'meta.desc.rooms': 'Habitaciones en Arequipa con desayuno frente al jardín, wifi gratuito, agua caliente las 24 horas y estacionamiento privado vigilado. Reserva directa en La Gruta.',
      'meta.desc.reservas': 'Reserva directa en el Hotel La Gruta, Arequipa. Cuéntanos tus fechas: te recomendamos la habitación ideal y confirmamos la disponibilidad personalmente.',
      'meta.desc.experiencias': 'Tours y experiencias en Arequipa con operadores locales de confianza, organizados desde la recepción del Hotel La Gruta.',
      'meta.desc.galeria': 'Fotos del Hotel La Gruta en Arequipa: nuestras habitaciones, el jardín, la mesa y la ciudad que nos rodea.',

      'exp.eyebrow': 'Tours & aventuras',
      'exp.intro': 'Desde recepción diseñamos contigo cada salida: tours y experiencias con operadores locales de confianza. Tú solo disfrutas; nosotros nos ocupamos del resto.',
      'exp.badge': 'El más solicitado',
      'exp.consultWa': 'Consultar por WhatsApp',
      'exp.note': 'Tarifas a consulta, según la fecha y el tamaño del grupo. Antes de reservar, confirmamos contigo disponibilidad, horarios, punto de recojo y servicios incluidos.',
      'exp.itin.title1': 'Cóndores, sillar y volcanes',
      'exp.itin.title2': 'Tour por tour',
      'exp.itin.noteTitle': 'Sobre las tarifas',
      'exp.itin.endEyebrow': 'Desde recepción',
      'exp.itin.endTitle': 'Organizamos tu día <em>en Arequipa.</em>',
      'exp.itin.cta': 'Planear mi día',
      'exp.itin.book': 'Reservar mi estadía',
      'tour.colca.name': 'Cañón del Colca',
      'tour.colca.desc': 'El vuelo del cóndor en la Cruz del Cóndor, aguas termales en Chivay y pueblos coloniales. Full day o 2 días/1 noche.',
      'tour.colca.meta': 'Full day o 2D/1N',
      'tour.ciudadcampina.name': 'Ciudad & Campiña',
      'tour.ciudadcampina.desc': 'Yanahuara, el mirador de Carmen Alto, la Mansión del Fundador y el Molino de Sabandía en un solo recorrido por la campiña arequipeña.',
      'tour.ciudadcampina.meta': '4–5 h · salidas diarias',
      'tour.santacatalina.name': 'Monasterio de Santa Catalina',
      'tour.santacatalina.desc': 'Una ciudad dentro de la ciudad: claustros de colores, patios de sillar y cuatro siglos de historia a pocos pasos de la Plaza de Armas.',
      'tour.santacatalina.meta': '3 h · privado',
      'tour.sillar.name': 'Canteras de Sillar',
      'tour.sillar.desc': 'Desciende a la quebrada de Añashuayco, donde se extrajo la piedra blanca que construyó toda la Ciudad Blanca.',
      'tour.sillar.meta': '~3 h',
      'tour.rafting.name': 'Rafting en el Río Chili',
      'tour.rafting.desc': 'Rápidos de nivel II–III a 20 minutos del centro. Sin experiencia previa: guía bilingüe y equipo completo incluido.',
      'tour.rafting.meta': '3 h · turnos 8:00, 11:00 y 14:00',
      'tour.pillones.name': 'Catarata de Pillones',
      'tour.pillones.desc': 'Full day entre el Bosque de Piedras de Imata, vicuñas en la Reserva de Salinas y miradores de los tres volcanes.',
      'tour.pillones.meta': 'Full day',
      'tour.volcanes.name': 'Volcán Misti & Chachani',
      'tour.volcanes.desc': 'Ascenso de 2 días/1 noche con guía oficial de montaña UIAGM. Para quienes buscan la cima.',
      'tour.volcanes.meta': '2D/1N',

      'wa.ariaLabel': 'Escribir por WhatsApp',

      'modal.close': 'Cerrar',
      'modal.prevPhoto': 'Foto anterior',
      'modal.nextPhoto': 'Foto siguiente',
      'modal.amenity.wifi': 'Wifi gratis',
      'modal.amenity.water': 'Agua caliente 24 h',
      'modal.amenity.breakfast': 'Desayuno incluido',
      'modal.amenity.parking': 'Estacionamiento gratuito y vigilado',
      'modal.amenity.massage': 'Masaje con cita previa',
      'modal.book': 'Reservar esta habitación',
      'modal.services': 'Servicios del hotel',
      'modal.waMsg': 'Hola, quisiera consultar disponibilidad de la habitación «{room}» en Hotel La Gruta.',
      'hab.total': '{n} habitaciones · {t} tipos',
      'hab.unidades': '{n} habitaciones',
      'hab.filtro.label': 'Filtrar por tipo de habitación',
      'hab.filtro.todas': 'Todas',
      'hab.verFotos': 'Ver fotos',
      'hab.consultar': 'Consultar',
      'hab.nota': 'Al consultar confirmamos contigo la disponibilidad de la habitación que elegiste.',
      'rasgo.jardin': 'Vista al jardín',
      'rasgo.balcon': 'Balcón',
      'rasgo.terraza': 'Terraza',
      'rasgo.tina': 'Tina',
      'rasgo.jacuzzi': 'Jacuzzi',
      'rasgo.primerpiso': 'Primer piso',
      'rasgo.tranquila': 'Zona tranquila',
      'rasgo.vista': 'Vista a la ciudad',
    },

    en: {
      /* REDISEÑO 2026-10-29 */
      'rd.habitaciones.hero.titulo': 'Six ways<br><em>to rest</em>',
      'rd.habitaciones.hero.lead': 'Eighteen rooms in Selva Alegre, Arequipa, with breakfast included and a garden of our own.',
      'rd.habitaciones.hero.cta': 'Check availability',
      'rd.habitaciones.hero.ver': 'See the rooms',
      'rd.habitaciones.catalogo.titulo': 'Choose the one that suits your trip',
      'rd.habitaciones.noscript': 'To see the photos of each room, turn on JavaScript or message us on WhatsApp.',
      'rd.habitaciones.verMas': 'Photos and details',
      'rd.habitaciones.dato.salaEstar': 'Private sitting room',
      'rd.habitaciones.dato.accesoJardin': 'Direct garden access',
      'rd.habitaciones.dato.areaEstar': 'Separate sitting area',
      'rd.habitaciones.dato.camaKing': 'King bed',
      'rd.habitaciones.dato.tresCamas': 'Three beds',
      'rd.habitaciones.dato.dosCamas': 'Two separate beds',
      'rd.habitaciones.incluye.titulo': 'What every night includes',
      'rd.habitaciones.incluye.lead': 'It comes with every room, from the single to the suite.',
      'rd.habitaciones.incluye.desayuno.t': 'Breakfast included',
      'rd.habitaciones.incluye.desayuno.p': 'Every morning, facing the garden.',
      'rd.habitaciones.incluye.wifi.t': 'Free wifi',
      'rd.habitaciones.incluye.wifi.p': 'Free connection throughout your stay.',
      'rd.habitaciones.incluye.agua.t': 'Hot water 24 h',
      'rd.habitaciones.incluye.agua.p': 'At any hour, in every room.',
      'rd.habitaciones.incluye.parking.t': 'Private parking',
      'rd.habitaciones.incluye.parking.p': 'Free and supervised, for guests arriving by car.',
      'rd.habitaciones.incluye.horario': 'Check-in from 2:00 pm · Check-out by 11:00 am',
      'rd.habitaciones.incluye.ver': 'See photo',
      'rd.habitaciones.cierre.titulo': 'Book directly with us',
      'rd.habitaciones.cierre.p': 'No intermediaries: we confirm availability with you. Pick your dates and message us on WhatsApp; we’ll help you choose the room.',
      'rd.habitaciones.cierre.link': 'Go to Reservations',
      'rd.habitaciones.cierre.foto': 'The garden at La Gruta',
      /* REDISEÑO 2026-10-29 */
      'rd.inicio.hero.nombre': 'Hotel La Gruta · Selva Alegre, Arequipa',
      'rd.inicio.hero.titulo': 'Your rest, cared for<br><em>in every detail.</em>',
      'rd.inicio.avail.consultar': 'Check availability',
      'rd.inicio.avail.nota': 'WhatsApp opens with your dates and we confirm availability with you.',
      'rd.inicio.intro.titulo': 'A haven in the city',
      'rd.inicio.intro.jardin': 'To slow down, among hydrangeas and terraces.',
      'rd.inicio.habs.intro': 'Six room types, all with breakfast included, wifi and hot water around the clock.',
      'rd.inicio.svc.desayuno': 'Every morning, in the dining room facing the garden.',
      'rd.inicio.svc.rest': 'Inside the hotel, every day.',
      'rd.inicio.svc.jardin': 'To slow down, a few minutes from the historic centre.',
      'rd.inicio.svc.parking': 'Free and secured, inside the hotel.',
      'rd.inicio.svc.wifi': 'Free connection throughout your stay.',
      'rd.inicio.svc.agua': 'In your room, at any hour of the day.',
      'rd.inicio.gastro.titulo': 'Breakfast facing the garden',
      'rd.inicio.cierre.titulo': 'Book directly with the hotel',
      'rd.inicio.cierre.apoyo': 'We confirm availability with you and reply personally.',
      'rd.inicio.cierre.cta': 'Book my stay',
      /* REDISEÑO 2026-10-30 · Inicio por referencias */
      'rd.inicio.hero.reservar': 'Book your stay',
      'rd.inicio.hero.habitaciones': 'View rooms',
      'rd.inicio.hab.reserva': 'Quick booking',
      'rd.inicio.hab.n2': '2 rooms',
      'rd.inicio.hab.n3': '3 rooms',
      'rd.inicio.hab.n4': '4 rooms',
      'rd.inicio.hab.n5': '5 rooms',
      'rd.inicio.res.google': 'Google · 154 reviews',
      'rd.inicio.res.ta': 'Tripadvisor · 119 reviews',
      'rd.inicio.res.q1': '“The staff is friendly, helpful and welcoming.”',
      'rd.inicio.res.q2': '“A comfortable place and room. They brought food to us, in a quiet setting.”',
      'rd.inicio.res.q3': '“Excellent service. A very comfortable hotel with beautiful gardens, well worth considering.”',
      'rd.inicio.res.c1': 'Karena V · Tripadvisor · September 2026',
      'rd.inicio.res.c2': 'Andrew G · Tripadvisor · September 2026',
      'rd.inicio.res.c3': 'Jesus H · Tripadvisor · September 2026',
      'rd.inicio.res.titulo': 'What our guests say',
      'rd.reservas.hero.titulo': 'Book direct<br><em>at La Gruta</em>',
      'rd.reservas.hero.texto': 'Tell us your dates and we’ll confirm availability with you, with no middlemen.',
      'rd.reservas.hero.cta': 'Check availability',
      'rd.reservas.hero.wa': 'or message us on WhatsApp',
      'rd.reservas.ventajas.titulo': 'What you get when you book direct',
      'rd.reservas.ventajas.1.titulo': 'No middlemen',
      'rd.reservas.ventajas.1.texto': 'You talk directly with the hotel, and we help you choose your room.',
      'rd.reservas.ventajas.2.texto': 'Your room rate includes breakfast.',
      'rd.reservas.ventajas.3.titulo': 'Check-in 2:00 PM, check-out 11:00 AM',
      'rd.reservas.ventajas.3.texto': 'If you need different times, just ask the hotel.',
      'rd.reservas.form.titulo': 'Send us your enquiry',
      'rd.reservas.form.texto': 'Fill in the form and WhatsApp opens with your message ready. You decide whether to send it.',
      'rd.reservas.confianza.titulo': 'What our guests say',
      'rd.reservas.confianza.cta': 'Check my dates',
      'rd.reservas.condiciones.titulo': 'Booking and stay conditions',
      'rd.reservas.canales.titulo': 'Message or call us',
      'rd.reservas.canales.texto': 'If you’d rather talk it through, we’ll help you personally on WhatsApp or by phone.',
      'rd.reservas.canales.wa': 'Message us on WhatsApp',
      'rd.reservas.canales.tel': 'Call +51 974 330 699',
      'rd.estrellas.5': '5 out of 5 stars',
      'rd.mapa.nombre': 'Map showing the location of Hotel La Gruta',
      'rd.reservas.canales.nota': 'WhatsApp +51 974 330 699 · Email:',
      'rd.experiencias.hero.sub': 'From the Colca Canyon to the volcanoes: seven outings we plan with you from our front desk.',
      'rd.experiencias.tours.lead': 'Seven outings we arrange from the hotel. Write to us about the one you like and we will confirm the details.',
      'rd.experiencias.organiza.titulo': 'We arrange it from the front desk',
      'rd.experiencias.cierre.titulo': 'Book, and we’ll plan your days',
      'rd.experiencias.cierre.texto': 'Book your stay and we’ll help you plan your time in Arequipa. We confirm availability with you.',
      'rd.experiencias.cierre.wa': 'Plan my day on WhatsApp',
      'rd.galeria.hero.lead': 'A hotel with its own garden in Selva Alegre, Arequipa. Breakfast included, booked directly with us.',
      'rd.galeria.hero.ver': 'See the gallery',
      'rd.galeria.prueba': '4.4 out of 5 on Tripadvisor',
      'rd.galeria.intro': 'Photos of the hotel in four walks: the garden, the rooms, the table and the reception.',
      'rd.galeria.jardin.titulo': 'The garden',
      'rd.galeria.jardin.texto': 'Among hydrangeas, roses and terraces with tables, the garden invites you to slow down.',
      'rd.galeria.cap.gruta': 'Stone grotto beside the hotel, with a decorative ornament.',
      'rd.galeria.cap.pergola': 'Pergola with armchairs, among the garden terraces.',
      'rd.galeria.jardin.nota': 'Tables under parasols, a pergola with armchairs and a stone stairway between the terraces.',
      'rd.galeria.hab.titulo': 'Six types of room',
      'rd.galeria.hab.texto': 'From the Single Room to the Suite, for travelling alone, as a couple or in a group. Suites 104 and 212 have a jacuzzi.',
      'rd.galeria.cap.suite': 'Suite: a jacuzzi beside the bed.',
      'rd.galeria.cap.semisuite': 'Semi Suite: separate bedroom and sitting room.',
      'rd.galeria.cap.matrimonial': 'Double Room: a desk and natural light.',
      'rd.galeria.hab.nota': 'Each type has its own page with capacity, photos and direct booking.',
      'rd.galeria.hab.link': 'See the rooms',
      'rd.galeria.cap.doble': 'Twin Room: two beds.',
      'rd.galeria.cap.triple': 'Triple Room: three beds.',
      'rd.galeria.cap.individual': 'Single Room: with a desk.',
      'rd.galeria.mesa.titulo': 'Breakfast is included',
      'rd.galeria.mesa.texto': 'Fruit, bread, juices and coffee every morning, in a dining room with windows onto the garden. There is also a restaurant and bar.',
      'rd.galeria.cap.comedor': 'Dining room with windows onto the garden.',
      'rd.galeria.casa.titulo': 'The reception and lounge, by day and by night',
      'rd.galeria.casa.texto': 'A wooden reception desk, a sitting room with books and private parking, in Selva Alegre, Arequipa.',
      'rd.galeria.casa.nota': 'Free wifi and hot water around the clock.',
      'rd.galeria.prueba.bookingNota': '“Superb” on Booking',
      'rd.galeria.prueba.tripNota': 'out of 5 on Tripadvisor',
      'rd.galeria.prueba.casaNota': 'Breakfast included, free wifi and private parking.',
      // Condiciones de reservas: ver docs/RESERVAS-CONDICIONES.md.
      "footer.terms": "Terms and conditions",
      "footer.data": "About your information",
      "footer.claims": "Complaints book",
      "footer.legalNav": "Booking information",
      "rv.consultNotice": "Sending this enquiry does not confirm a booking. The hotel will provide availability, the rate and the applicable conditions.",
      "rv.dataLink": "Learn how your information is sent",
      "rv.process.eye": "How to book",
      "rv.process.title": "Your stay, <em>step by step</em>",
      "rv.process.1.title": "Tell us your dates",
      "rv.process.1.text": "Enquire via WhatsApp or email. Tell us your dates, the number of guests and your preferred room.",
      "rv.process.2.title": "Receive your proposal",
      "rv.process.2.text": "The hotel provides availability, the rate, the included services and the conditions for your stay.",
      "rv.process.3.title": "Arrange confirmation",
      "rv.process.3.text": "Agree the deposit, balance and payment method with the hotel. Request booking confirmation through your contact channel.",
      "rv.process.cta": "Start on WhatsApp",
      "rv.process.formLink": "I’d rather fill in the form",
      "rv.terms.eye": "Information for your stay",
      "rv.terms.title": "Booking and stay <em>conditions</em>",
      "rv.terms.intro": "Read this information before confirming. The hotel will explain the specific conditions of your proposal and answer your questions personally.",
      "rv.terms.updated": "Updated on 11 October 2026",
      "rv.terms.payment.title": "Bookings and payment methods",
      "rv.terms.payment.text": "Enquiries are subject to availability. A deposit of 50% of the booking total is usually arranged; the amount, deadline and balance payment are agreed directly with the hotel.",
      "rv.terms.payment.note": "Confirm availability and the amount with the hotel before making a bank transfer or a Yape payment.",
      "rv.terms.payment.bank": "Bank transfer in Peruvian soles",
      "rv.terms.payment.holder": "Account holder",
      "rv.terms.payment.account": "BCP current account in soles",
      "rv.terms.payment.cci": "Interbank account code (CCI)",
      "rv.terms.payment.yape": "Yape · LUCIUS S.A.C.",
      "rv.terms.payment.agencies": "For agencies, companies or groups, agree the deposit, balance and payment deadlines directly before confirming.",
      "rv.terms.changes.title": "Changes and cancellations",
      "rv.terms.changes.text": "Before confirming or paying a deposit, ask the hotel about the conditions for changes, cancellations, deposit refunds, no-shows and early departure. These requests are handled directly via WhatsApp or email.",
      "rv.terms.stay.title": "Arrival, departure and special requests",
      "rv.terms.stay.hours": "Check-in from 2:00 PM. Check-out by 11:00 AM.",
      "rv.terms.stay.text": "For early check-in, late check-out, stays with children, pets or visitors, ask the hotel about the conditions before confirming your booking.",
      "rv.terms.services.title": "Included services and additional purchases",
      "rv.terms.services.text": "The accommodation rate includes breakfast. Private parking is free. Ask about the price and conditions for laundry, the café, room service and other food or drinks before requesting them.",
      "rv.terms.bridal.title": "Bridal package",
      "rv.terms.bridal.text": "The bridal package is arranged personally. Ask about buffet breakfast, room service, decoration, a jacuzzi, garden photography and complimentary wine or sparkling wine. The room, duration, booking notice, price and inclusions are confirmed in the hotel’s proposal.",
      "rv.terms.bridal.cta": "Enquire about the bridal package",
      "rv.terms.data.title": "About your information",
      "rv.terms.data.text": "This form prepares an enquiry using the name, phone number, optional email, dates, guests, room and message you enter. Choosing WhatsApp or email opens that service with the prepared message; you decide whether to send it. No payment is collected on this website.",
      "rv.terms.data.contact": "For enquiries about the information you share, contact the hotel’s official email address.",
      "rv.terms.claims.title": "Complaints book",
      "rv.terms.claims.text": "The hotel has a physical complaints book. You can request it from staff during your visit.",
      "rv.terms.business.title": "Business details",
      "rv.terms.business.name": "Registered company name",
      "rv.terms.business.tax": "Tax identification number (RUC)",
      "rv.terms.business.address": "Address",
      "rv.terms.business.email": "Official contact email",

      'nav.book': '▸ Book',
      // Marco (header + barra inferior móvil): ver "MARCO" en site.css.
      'hdr.directions': 'How to get here',
      'stack.showAll': 'Show all',
      'hdr.navLabel': 'Main navigation',
      'bar.menu': 'Menu',
      'bar.mail': 'Email',
      'bar.close': 'Close',
      'bar.book': 'Book now',
      'wa.short': 'Chat with us',
      'menu.social.label': 'Follow us',
      'menu.nav.home': 'Home',
      'menu.nav.rooms': 'Rooms',
      'menu.nav.reservas': 'Booking',
      'menu.nav.experiencias': 'Experiences',
      'menu.nav.galeria': 'Gallery',
      'hero.galeria.title': 'La Gruta<br><em>in pictures</em>',
      'gal.eyebrow': 'Gallery',
      'gal.title': 'La Gruta, up close',
      'gal.intro': 'A walk through our rooms, the garden, our table and the city around us.',
      'gal.cta.title': 'Can you picture yourself here?',
      'gal.cta.text': 'Tell us your dates and we will confirm availability with you personally.',
      'gal.filtrosLabel': 'Filter photos',
      'gal.f.todas': 'All',
      'gal.f.hotel': 'The hotel',
      'gal.f.habitaciones': 'Rooms',
      'gal.f.gastronomia': 'Dining',
      'gal.f.arequipa': 'Arequipa',
      'gal.visor.label': 'Photo viewer',
      'gal.visor.cerrar': 'Close',
      'gal.visor.anterior': 'Previous photo',
      'gal.visor.siguiente': 'Next photo',
      // Galería: texto alternativo de cada foto (también es el pie del visor).
      'gal.p.fachada-jardin': 'La Gruta seen from the garden, with canopies and tables on the lawn',
      'gal.p.suite': 'Suite with king-size bed and welcome touches',
      'gal.p.hortensias': 'Blue hydrangeas in front of the garden wall',
      'gal.p.catedral-misti': 'Arequipa Cathedral and the Misti volcano at sunset',
      'gal.p.sombrilla': 'Table under a parasol among the garden’s greenery',
      'gal.p.desayuno-mesa': 'Breakfast served: fruit, bread, juices and coffee',
      'gal.p.semisuite': 'Semi Suite with separate bedroom and lounge',
      'gal.p.patio-amarillo': 'Courtyard with hydrangeas in front of the hotel’s yellow façade',
      'gal.p.matrimonial': 'Double Room with desk and natural light',
      'gal.p.matrimonial-sala': 'Double Room with a sitting area and desk',
      'gal.p.colca': 'Condor soaring over the Colca Canyon',
      'gal.p.jacuzzi-suite': 'The Suite’s jacuzzi set with petals and candles',
      'gal.p.cafe-libro': 'Coffee and an open book on the garden terrace',
      'gal.p.suite-cama': 'The Suite’s bed dressed for a special occasion',
      'gal.p.recepcion-noche': 'The hotel entrance lit at dusk',
      'gal.p.santa-catalina': 'Courtyard of the Santa Catalina Monastery',
      'gal.p.comedor': 'Dining room with windows onto the garden',
      'gal.p.triple': 'Triple Room with three beds',
      'gal.p.triple-camas': 'Triple Room with three beds and wood panelling',
      'gal.p.pergola': 'Pergola with armchairs in the garden',
      'gal.p.balcon-jardin': 'Balcony overlooking the garden and the stone terraces',
      'gal.p.misti-nubes': 'The Misti volcano above a sea of clouds',
      'gal.p.semisuite-sala': 'The Semi Suite’s lounge with armchairs',
      'gal.p.escalinata': 'Stone steps leading to the garden',
      'gal.p.doble': 'Twin Room with two beds',
      'gal.p.buffet': 'Breakfast buffet with bread and hot dishes',
      'gal.p.ventanal': 'Room window with a view of the garden',
      'gal.p.bano-suite': 'The Suite’s bathroom with a glass shower',
      'gal.p.yanahuara': 'The sillar arches of the Yanahuara viewpoint, with the Misti behind',
      'gal.p.doble-sala': 'Sitting area with armchairs in the Double room',
      'gal.p.individual': 'Single Room with desk',
      'gal.p.bano-semisuite': 'The Semi Suite’s bathroom',
      'gal.p.sillar': 'Sillar quarries on the outskirts of Arequipa',
      'gal.p.individual-sala': 'Armchairs by the window in the Single Room',
      'gal.p.bano-matrimonial': 'Matrimonial bathroom with a glass-block shower',
      'gal.p.pillones': 'Pillones waterfall',
      'gal.p.bano-triple': 'The Triple Room’s bathroom',
      'gal.p.rafting': 'Rafting on the Chili River',
      'gal.p.gruta': 'The stone grotto covered in greenery, among cacti',
      'gal.p.recepcion': 'Reception desk in wood, with a tiled floor',
      'gal.p.hora-azul': 'The hotel building with its lights on at blue hour',
      'gal.p.rosas-ventana': 'Pink roses in a vase by the window, with the garden foliage behind',
      'gal.p.fachada-azul': 'The La Gruta facade at dusk, with a blue sky and its lights on',
      'gal.p.ventana-jardin': 'The garden seen through a window',
      'gal.p.rosas': 'Colourful roses in the garden, beside the staircase',
      'gal.p.terraza-atardecer': 'Table with a parasol on the terrace at sunset',
      'gal.p.sala-lectura': 'Lounge area with a bookshelf and armchairs',
      'gal.p.suite-jacuzzi': 'Suite with a jacuzzi beside the bed',
      'gal.p.desayuno-jugos': 'Coffee and juices at the breakfast buffet',
      'gal.p.terraza-plantas': 'Terrace with a table, parasol and plants',
      'gal.p.escalera-flores': 'Outdoor staircase and balcony among flowers',
      'gal.p.estacionamiento': 'The hotel’s private parking',
      'gal.p.misti-campina': 'The Arequipa countryside with the Misti behind',

      'hero.home.title': 'Your rest, cared for <em>in every detail.</em>',
      'hero.home.sub': 'Boutique hotel in Selva Alegre, Arequipa.',
      'hero.rooms.title': 'Rest in the comfort and calm of La Gruta.',
      'hero.reservas.title': 'Your next pause starts here.',
      'hero.experiencias.title1': 'Experience Arequipa',
      'hero.experiencias.title2': 'from La Gruta',

      'avail.checkin': 'Check In',
      'avail.checkout': 'Check Out',
      'avail.guests': 'Guests',
      'avail.guest1': '1 guest',
      'avail.guest2': '2 guests',
      'avail.guest3': '3 guests',
      'avail.guest4': '4+ guests',
      'avail.consult': 'Check',
      'avail.dateFormat': 'dd/mm/yyyy',

      'avail.a11y.checkin': 'Check-in date',
      'avail.a11y.checkout': 'Check-out date',
      'avail.a11y.guests': 'Number of guests',
      'picker.clear': 'Clear',
      'picker.prevMonth': 'Previous month',
      'picker.nextMonth': 'Next month',

      'welcome.editorial.eye': 'Welcome to La Gruta',
      'welcome.editorial.title': 'A haven in the city.<br>Another way to <em>experience</em> Arequipa.',
      'welcome.editorial.desc': 'Just minutes from the historic centre, a garden to slow down in. Comfortable rooms, personal attention and the calm of feeling well looked after.',
      'welcome.editorial.caption': 'The garden at La Gruta · Selva Alegre',
      'welcome.sello': '4.4 out of 5<br>Tripadvisor',
      'welcome.ben.desayuno': 'Breakfast included',
      'welcome.ben.parking': 'Private parking',
      'welcome.ben.wifi': 'Free wifi',
      'cl.sellos.label': 'Guest ratings',
      'cl.hab.fotos': 'View photos',
      'cl.wa': 'Message us on WhatsApp',
      'cl.svc.title': 'Designed for your <em>comfort</em>',
      'cl.svc.rest': 'Restaurant and bar',
      'cl.svc.jardin': 'Beautiful gardens',
      'cl.svc.agua': 'Hot water 24 hours',
      'cl.comollegar': 'Get directions',
      'cl.visor.cerrar': 'Close',
      'cl.visor.prev': 'Previous photo',
      'cl.visor.next': 'Next photo',
      'cl.visor.ampliar': 'Enlarge photo',
      'welcome.cta.book': 'Book direct',
      'rd.inicio.remanso.wa': 'Ask on WhatsApp',
      'welcome.cta.wa': 'Message us on WhatsApp',
      'welcome.cta.nota': 'No middlemen: we confirm availability with you personally.',
      'welcome.cta.horario': 'Check‑in 2:00 pm · check‑out 11:00 am.',
      'welcome.sello.sr': 'Tripadvisor rating:',
      'rooms.editorial.title': 'Find your own kind of <em>rest.</em>',
      'rooms.editorial.all': 'All rooms ↗',
      'rooms.editorial.explore': 'Explore this room ↗',
      'welcome.script': 'Welcome to',
      'welcome.title': 'A garden where the <em>White City</em> turns to calm.',
      'welcome.desc': 'La Gruta has beautiful gardens and is set in an elegant residential area, just minutes from Arequipa’s historic centre and shopping district. It offers a welcoming, homely atmosphere, warm and attentive service, and spacious, comfortable rooms with wall-to-wall carpeting.',

      'homemap.eyebrow': 'Why La Gruta',
      'homemap.title': 'Here, silence <em>is part of the service.</em>',
      'homemap.desc': 'On a quiet street in Selva Alegre, La Gruta brings together its own garden, comfortable rooms and personalized service. The historic centre is a stroll away, so you can enjoy Arequipa at your own pace.',
      'homemap.addressLabel': 'Address',
      'homemap.checkinLabel': 'Check-in',
      'homemap.checkoutLabel': 'Check-out',
      'homemap.directions': 'Get directions ›',
      'homemap.book': 'Book direct',
      'homemap.plaza': 'Plaza de Armas',
      'homemap.poi.santa-catalina': 'Santa Catalina',
      'homemap.poi.san-francisco': 'San Francisco',
      'homemap.poi.campo-redondo': 'Campo Redondo',
      'homemap.poi.bares': 'Bars & cafés',
      'homemap.recenter': 'Centre on the hotel and Plaza de Armas',

      'bodas.eyebrow': "Bridal package",
      'bodas.title': 'Get ready and pose in <em>our garden</em>',
      'bodas.desc': 'Arrive at La Gruta to change, have your makeup done and get ready in peace, then finish with a photo session in our garden. A serene, unhurried start to your big day.',
      'bodas.cta': "Enquire about the bridal package",
      'bodas.note': 'No commitment · We reply personally',

      'reviews.eyebrow': 'Guest reviews',
      'reviews.title': 'What our guests remember',
      'reviews.booking.tag': 'Fantastic',
      'reviews.booking.count': '15 reviews',
      'reviews.tripadvisor.count': '119 reviews',
      'reviews.ta.bravo': 'Bravo!',
      'reviews.ta.score': '4.4 out of 5',
      'reviews.booking.score': '9.3',
      'reviews.t2.date': 'Sep 2026',
      'reviews.arrow': 'See more reviews',
      'reviews.cta.text': 'Book direct with the hotel: we take care of you personally.',
      'reviews.cta.btn': 'Check availability',
      'reviews.b1.country': 'Lithuania',
      'reviews.b1.text': 'Beautiful, quiet place in Arequipa with an absolutely exceptional receptionist. Thank you so much for all your help!!',
      'reviews.b2.country': 'Chile',
      'reviews.b2.text': 'Quiet place, friendly staff, varied breakfast, comfortable beds.',
      'reviews.t2.text': 'The hotel is very comfortable, clean, and the staff are very attentive.',

      'rooms.count': 'Rooms',
      'rooms.info.title': 'Your stay, cared for <em>in every detail</em>',
      'rooms.info.text': 'All our rooms include breakfast facing the garden, free wifi, hot water around the clock and secure private parking. <strong>Book directly with us and we’ll help you choose the ideal room</strong>, arrange your transfer and, if you wish, a massage by appointment to end the day.',
      'rooms.viewAll': 'View all',
      'rooms.viewMore': 'View more',
      'rooms.book': 'Book',
      'rooms.suite.name': 'Suite',
      'rooms.suite.descShort': 'Our most exclusive suite: a jacuzzi for two, private sitting room and direct garden access.',
      'rooms.suite.detail': 'The most spacious and private space at La Gruta. Direct garden access, a sitting room separate from the bedroom and a jacuzzi for two to end the day in calm. Ideal for longer stays, anniversaries or a stay with extra space and comfort.',
      'rooms.matrimonial.name': 'Double Room',
      'rooms.matrimonial.descHomeShort': 'A king bed and garden views for a peaceful stay together.',
      'rooms.matrimonial.descShort': 'King bed and garden views, designed for restful stays as a couple.',
      'rooms.matrimonial.detail': 'A king bed, garden light through the window and the calm of Selva Alegre. Enjoy Arequipa together, with the comfort and care of La Gruta.',
      'rooms.semisuite.name': 'Semi Suite',
      'rooms.semisuite.descShort': 'Independent sitting area and garden views: suite comfort in a more intimate format.',
      'rooms.semisuite.detail': 'Suite comfort in a more intimate format. It has an independent sitting area to read, work or share a coffee at the end of the day, with the garden always in view.',
      'rooms.triple.name': 'Triple Room',
      'rooms.triple.descShort': 'Three beds and room enough for everyone to rest equally well, with family or friends.',
      'rooms.triple.detail': 'Three beds in a spacious room, designed for families or groups who don’t want to compromise on comfort. Room to move freely and the same calm as the rest of the hotel, so everyone wakes up rested.',
      'rooms.doble.name': 'Twin Room',
      'rooms.doble.descShort': 'Two separate beds in a serene setting, ideal for sharing the trip in comfort.',
      'rooms.doble.detail': 'Two separate beds in a serene setting: the natural choice for friends or travel companions who want to share the room, not the bed. All of La Gruta’s comfort, with the privacy of your own rest.',
      'rooms.individual.name': 'Single Room',
      'rooms.individual.descShort': 'A cosy room to travel at your own pace and rest in comfort.',
      'rooms.individual.detail': 'Cosy and thoughtfully designed for solo travellers: a comfortable room to plan your day, rest well and enjoy Arequipa at your own pace.',

      'jardin.title': 'A garden where time stands still',
      'jardin.desc': 'La Gruta’s garden, with its mature trees, invites you to spend time outdoors. Sunbathe on the lawn, read in the shade or share a coffee at sunset. It is the heart of the hotel and part of every stay.',
      'novia.eyebrow': "Bridal package",
      'novia.title': 'Before “I do”,<br><em>a moment just for you.</em>',
      'novia.desc': 'Get ready in peace, take a break and capture your first photos in La Gruta’s garden. Start at your own pace before heading out for your big day.',
      'novia.preparar.title': 'Your space to get ready',
      'novia.preparar.desc': 'A room to change and do your makeup without rushing.',
      'novia.pausa.title': 'A moment for yourself',
      'novia.pausa.desc': 'Relax and enjoy something to eat before heading out.',
      'novia.fotos.title': 'Your first photos',
      'novia.fotos.desc': 'The hotel garden as the setting for your photo session.',
      'novia.cta': 'Ask about my date',
      'novia.note': "Tell us your date. We will explain the room, services, price and conditions of the bridal package.",
      'novia.whatsapp': "https://wa.me/51974330699?text=Hello%20Hotel%20La%20Gruta%2C%20I%20would%20like%20to%20ask%20about%20availability%20and%20details%20of%20the%20bridal%20package.",
      'novia.jardin.alt': 'La Gruta’s garden, with trees, flowers and outdoor spaces',
      'novia.jardin.caption': 'The garden, part of your story.',
      'novia.habitacion.alt': 'One of the rooms at La Gruta',
      'novia.habitacion.caption': 'A space to get ready at your own pace.',

      'gastro.eyebrow': 'Restaurant & Bar',
      'gastro.chip.breakfast': 'Breakfast',
      'gastro.chip.rest': 'Restaurant',
      'gastro.chip.bar': 'Open bar',
      'gastro.chip.wine': 'Wine & champagne',
      'gastro.title': 'Breakfast and Arequipa cuisine, <em>facing the garden</em>',
      'gastro.desc': 'Start the day unhurried, facing the garden, in our dining room. There is also a restaurant and bar.',
      'gastro.note': 'To complete the experience: in-house massages by appointment. Arrange it at reception.',
      'gastro.cta': 'Book with breakfast included',

      'faq.eyebrow': 'Help',
      'faq.title': 'Frequently asked <em>questions</em>',
      'faq.q1': 'What time are check-in and check-out?',
      'faq.a1': "Check-in from 2:00 PM and check-out by 11:00 AM. For early check-in or late check-out, ask the hotel about the conditions before booking.",
      'faq.q2': 'How do I book?',
      'faq.a2': 'By WhatsApp (+51 974 330 699), through this website’s form, or by writing to {correo}. We reply personally and confirm availability with you.',
      // Texto del HTML estático (sin la dirección: la arma correo.js al cargar).
      'faq.a2.sinCorreo': 'By WhatsApp (+51 974 330 699), through this website’s form, or by email. We reply personally and confirm availability with you.',
      'faq.q3': 'Do you have parking?',
      'faq.a3': 'Yes, private parking inside the hotel, free and secured.',
      'faq.q4': 'Where are you located exactly?',
      'faq.a4': 'Pasaje La Gruta 304, Urb. Selva Alegre: a quiet street in a residential neighbourhood of Arequipa, away from the bustle.',
      'faq.q5': 'Can tours be arranged from the hotel?',
      'faq.a5': 'Yes. From reception we arrange city tours, Colca Canyon, rafting and more, with trusted local operators.',
      'faq.q6': 'Do you accept pets?',
      'faq.a6': 'Message us on WhatsApp before booking and we’ll arrange it based on availability.',
      'faq.bridge': 'Didn’t find your answer?',

      'footer.tagline': 'Boutique hotel · Arequipa, Peru',
      'footer.desc': 'A garden, comfort and personalized service in Arequipa.',
      'footer.navTitle': 'Navigation',
      'footer.contactTitle': 'Contact',
      'footer.near': 'A boutique hotel in Selva Alegre, Arequipa.',
      'footer.credit': '',

      'experience.eyebrow': 'The experience',
      'experience.title': 'Unhurried moments to enjoy',

      'rv.eye': 'Direct with the hotel',
      'rv.title': 'Let’s design <em>your stay</em> together.',
      'rv.desc': 'Tell us your dates and what you hope for from your trip. We’ll recommend the ideal room and confirm availability personally.',
      'rv.contact.whatsapp': 'WhatsApp',
      'rv.contact.phone': 'Phone',
      'rv.contact.email': 'Email',
      'rv.contact.checkinout': 'Check-in / out',

      'contact.eyebrow': 'Book direct',
      'contact.title': 'Write to us and we will reply <em>personally.</em>',
      'contact.desc': 'Ask about availability, rates or any detail of your stay. We reply personally.',
      'rv.form.requiredNote': 'Required fields',
      'rv.form.label': 'Enquiry form',
      'rv.form.nombre': 'Full name',
      'rv.form.nombrePh': 'Your name',
      'rv.form.telefono': 'Phone',
      'rv.form.correo': 'Email address',
      'rv.form.correoPh': 'email@example.com',
      'rv.form.habitacion': 'Room',
      'rv.form.seleccionar': 'Select',
      'rv.form.huespedes': 'Guests',
      'rv.form.huespedesPh': '1',
      'rv.form.llegada': 'Arrival',
      'rv.form.salida': 'Departure',
      'rv.form.mensaje': 'Additional message',
      'rv.form.mensajePh': 'Celebrating something special? Any preferences?',
      'rv.form.submit': 'Check availability on WhatsApp',
      "rv.err.required": "Please fill in this field.",
      "rv.err.email": "Enter a valid email address, e.g. name@email.com.",
      "rv.err.past": "Arrival can’t be before today.",
      "rv.err.range": "Departure must be after arrival.",
      "rv.err.summary": "Check the highlighted fields to send your enquiry.",
      "rv.note.wa": "WhatsApp opened with your request ready to send.",
      "rv.note.mail": "Your email app opened with the request ready to send.",
      'rv.form.mailtoLink': 'I’d rather ask by email',
      'rv.card1.title': 'Arrival and departure',
      'rv.card1.text': "Check-in from 2:00 PM and check-out by 11:00 AM. Contact the hotel if you need different times.",
      'rv.card2.title': 'Book direct',
      'rv.card2.text': 'No middlemen: we confirm availability with you before you book and help you choose the room.',
      'rv.card3.title': 'Breakfast included',
      'rv.card3.text': "The accommodation rate includes breakfast. Ask the hotel about any other food, drinks or services you wish to request.",
      'rv.card4.title': "Free private parking",
      'rv.card4.text': "Free private parking for hotel guests.",
      'rv.cards.eye': 'Before you book',
      'rv.cards.title': 'The essentials, <em>at a glance</em>',
      'a11y.skip': 'Skip to content',
      'meta.title': 'Hotel La Gruta | Boutique hotel with a garden in Arequipa',
      'meta.page': '{page} | Hotel La Gruta, Arequipa',
      'meta.desc': 'Boutique hotel in Selva Alegre, Arequipa: its own garden, spacious and comfortable rooms, breakfast included and personal service. Book direct.',
      'meta.desc.rooms': 'Rooms in Arequipa with breakfast facing the garden, free wifi, hot water around the clock and secure private parking. Book direct at La Gruta.',
      'meta.desc.reservas': 'Book direct at Hotel La Gruta, Arequipa. Tell us your dates: we will recommend the ideal room and confirm availability personally.',
      'meta.desc.experiencias': 'Tours and experiences in Arequipa with trusted local operators, arranged from the reception of Hotel La Gruta.',
      'meta.desc.galeria': 'Photos of Hotel La Gruta in Arequipa: our rooms, the garden, our table and the city around us.',

      'exp.eyebrow': 'Tours & adventures',
      'exp.intro': 'From reception we plan every outing with you: tours and experiences with trusted local operators. You simply enjoy; we take care of the rest.',
      'exp.badge': 'Most requested',
      'exp.consultWa': 'Ask on WhatsApp',
      'exp.note': 'Rates on request, depending on the date and group size. Before booking, we confirm availability, schedule, pickup point and included services with you.',
      'exp.itin.title1': 'Condors, sillar & volcanoes',
      'exp.itin.title2': 'Tour by tour',
      'exp.itin.noteTitle': 'About our rates',
      'exp.itin.endEyebrow': 'From our front desk',
      'exp.itin.endTitle': 'We plan your day <em>in Arequipa.</em>',
      'exp.itin.cta': 'Plan my day',
      'exp.itin.book': 'Book my stay',
      'tour.colca.name': 'Colca Canyon',
      'tour.colca.desc': 'The condor’s flight at Cruz del Cóndor, hot springs in Chivay and colonial villages. Full day or 2 days/1 night.',
      'tour.colca.meta': 'Full day or 2D/1N',
      'tour.ciudadcampina.name': 'City & Countryside',
      'tour.ciudadcampina.desc': 'Yanahuara, the Carmen Alto viewpoint, the Mansión del Fundador and the Sabandía Mill in a single tour of the Arequipa countryside.',
      'tour.ciudadcampina.meta': '4–5 h · daily departures',
      'tour.santacatalina.name': 'Santa Catalina Monastery',
      'tour.santacatalina.desc': 'A city within the city: colorful cloisters, sillar-stone courtyards and four centuries of history steps from Plaza de Armas.',
      'tour.santacatalina.meta': '3 h · private',
      'tour.sillar.name': 'Sillar Stone Quarries',
      'tour.sillar.desc': 'Descend into the Añashuayco ravine, where the white stone that built the whole White City was quarried.',
      'tour.sillar.meta': '~3 h',
      'tour.rafting.name': 'Rafting on the Chili River',
      'tour.rafting.desc': 'Class II–III rapids just 20 minutes from downtown. No previous experience needed: bilingual guide and full gear included.',
      'tour.rafting.meta': '3 h · departures at 8:00, 11:00 & 14:00',
      'tour.pillones.name': 'Pillones Waterfall',
      'tour.pillones.desc': 'A full day through the Imata Stone Forest, vicuñas in the Salinas Reserve, and viewpoints of the three volcanoes.',
      'tour.pillones.meta': 'Full day',
      'tour.volcanes.name': 'Misti & Chachani Volcanoes',
      'tour.volcanes.desc': '2-day/1-night ascent with an official UIAGM mountain guide. For those seeking the summit.',
      'tour.volcanes.meta': '2D/1N',

      'wa.ariaLabel': 'Message us on WhatsApp',

      'modal.close': 'Close',
      'modal.prevPhoto': 'Previous photo',
      'modal.nextPhoto': 'Next photo',
      'modal.amenity.wifi': 'Free Wifi',
      'modal.amenity.water': 'Hot water 24/7',
      'modal.amenity.breakfast': 'Breakfast included',
      'modal.amenity.parking': 'Free, monitored parking',
      'modal.amenity.massage': 'Massage by appointment',
      'modal.book': 'Book this room',
      'modal.services': 'Hotel services',
      'modal.waMsg': 'Hello, I would like to check availability for the {room} at Hotel La Gruta.',
      'hab.total': '{n} rooms · {t} types',
      'hab.unidades': '{n} rooms',
      'hab.filtro.label': 'Filter by room type',
      'hab.filtro.todas': 'All',
      'hab.verFotos': 'View photos',
      'hab.consultar': 'Ask',
      'hab.nota': 'When you ask, we confirm availability with you for the room you choose.',
      'rasgo.jardin': 'Garden view',
      'rasgo.balcon': 'Balcony',
      'rasgo.terraza': 'Terrace',
      'rasgo.tina': 'Bathtub',
      'rasgo.jacuzzi': 'Jacuzzi',
      'rasgo.primerpiso': 'Ground floor',
      'rasgo.tranquila': 'Quiet side',
      'rasgo.vista': 'City view',
    }
  };

  /* URLs de cada página en cada idioma. Las usan el generador de /en/
     (scripts/generar-idiomas.mjs), el sitemap y los tests. El neerlandés se
     retiró del sitio el 2026-10-13 (pedido del hotel). */
  var RUTAS = {
    es: { home: '/', rooms: '/habitaciones/', reservas: '/reservas/', experiencias: '/experiencias/', galeria: '/galeria/' },
    en: { home: '/en/', rooms: '/en/rooms/', reservas: '/en/booking/', experiencias: '/en/experiences/', galeria: '/en/gallery/' }
  };
  var paginaLang = document.documentElement.getAttribute('lang');
  var currentLang = LANGS.indexOf(paginaLang) !== -1 ? paginaLang : DEFAULT_LANG;

  // La misma página en otro idioma: su <link rel="alternate" hreflang> (se
  // usa sólo la ruta, para que funcione igual en local que publicado).
  function urlEnIdioma(lang) {
    var alt = document.querySelector('link[rel="alternate"][hreflang="' + lang + '"]');
    if (!alt) return null;
    try { var u = new URL(alt.getAttribute('href'), location.href); return u.pathname; } catch (e) { return null; }
  }

  // Enlaces antiguos con ?lang=en (la etapa con un solo HTML por
  // página): se redirigen a la URL de ese idioma.
  try {
    var urlLang = new URLSearchParams(location.search).get('lang');
    var destino = urlLang && urlLang !== currentLang && LANGS.indexOf(urlLang) !== -1 && urlEnIdioma(urlLang);
    if (destino) location.replace(destino + location.hash);
  } catch (e) { /* sin URLSearchParams: se queda en la página */ }

  // La descripción ya viene en el HTML de cada página; se repasa por si un
  // HTML a mano quedara atrás del diccionario.
  function metadatos() {
    var activa = document.querySelector('.page.active');
    var pagina = activa ? activa.id.replace('page-', '') : 'home';
    var clave = pagina === 'home' ? 'meta.desc' : 'meta.desc.' + pagina;
    var desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', t(clave) !== clave ? t(clave) : t('meta.desc'));
  }

  // {correo}: la dirección del hotel no se escribe en este archivo (los
  // robots de spam la leerían); la arma correo.js en window.LG_CORREO.
  function t(key) {
    var dict = STRINGS[currentLang] || STRINGS[DEFAULT_LANG];
    var s = dict[key] !== undefined ? dict[key]
          : STRINGS[DEFAULT_LANG][key] !== undefined ? STRINGS[DEFAULT_LANG][key] : key;
    return s.indexOf('{correo}') === -1 ? s : s.split('{correo}').join(window.LG_CORREO || '');
  }

  function applyToDocument() {
    document.documentElement.setAttribute('lang', currentLang);
    metadatos();

    document.querySelectorAll('[data-i18n]').forEach(function (el) {
      el.textContent = t(el.getAttribute('data-i18n'));
    });
    document.querySelectorAll('[data-i18n-html]').forEach(function (el) {
      el.innerHTML = t(el.getAttribute('data-i18n-html'));
    });
    document.querySelectorAll('[data-i18n-attr]').forEach(function (el) {
      el.getAttribute('data-i18n-attr').split(';').forEach(function (pair) {
        var parts = pair.split(':');
        if (parts.length !== 2) return;
        el.setAttribute(parts[0].trim(), t(parts[1].trim()));
      });
    });

    document.querySelectorAll('.menu-lang-btn, .hdr-lang-btn').forEach(function (btn) {
      btn.classList.toggle('on', btn.getAttribute('data-lang') === currentLang);
      btn.setAttribute('aria-current', btn.getAttribute('data-lang') === currentLang ? 'true' : 'false');
    });
  }

  // Cambiar de idioma es ir a la misma página en ese idioma.
  function setLang(lang) {
    if (LANGS.indexOf(lang) === -1 || lang === currentLang) return;
    try { localStorage.setItem(STORAGE_KEY, lang); } catch (e) { /* localStorage bloqueado */ }
    var destino = urlEnIdioma(lang);
    if (destino) location.href = destino;
  }

  window.I18N = { t: t, setLang: setLang, getLang: function () { return currentLang; }, LANGS: LANGS,
                  RUTAS: RUTAS, STRINGS: STRINGS };

  applyToDocument();

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.menu-lang-btn, .hdr-lang-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { setLang(btn.getAttribute('data-lang')); });
    });
    // por si el DOM ya estaba listo cuando corrió applyToDocument() más
    // arriba (script con defer, suele ser el caso) hace falta reflejar el
    // estado "on" también en el primer pintado, no solo en cambios futuros.
    applyToDocument();
  });
})();
